import { HeaderCharmType, toggleCharm } from 'owa-header-store';
import { action } from 'satcheljs/lib/legacy';

export default action('toggleGetStartedPane')(function toggleGetStartedPane() {
    toggleCharm(HeaderCharmType.GetStartedCharm);
});
